
import { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

type OnboardingStepCardProps = {
  title: string;
  description: string;
  children: ReactNode;
  onBack?: () => void;
  onContinue: () => void;
  isLastStep?: boolean;
  hideButtons?: boolean;
};

const OnboardingStepCard = ({
  title,
  description,
  children,
  onBack,
  onContinue,
  isLastStep = false,
  hideButtons = false
}: OnboardingStepCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {children}
          
          {!hideButtons && (
            <div className="flex justify-between mt-8">
              {onBack && (
                <Button variant="outline" onClick={onBack}>
                  Back
                </Button>
              )}
              <div className="flex-1"></div>
              <Button onClick={onContinue}>
                {isLastStep ? 'Complete Setup' : 'Continue'}
              </Button>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default OnboardingStepCard;
